import { CesiumZone } from 'app/map/geometry/cesium/CesiumZones/CesiumZone';
import { ZoneService } from 'app/shared/zones/zone.service';
import { Cesium } from 'app/cesium';
import { ZoneCollection } from 'app/shared/collections/zones/zone_collection.service';
import { ClockHandler } from 'app/shared/time/clock_handler.service';
import { TerrainService } from 'app/map/services/terrain.service';

export class CesiumZonePositionSampler {
    private _zoneCollection: ZoneCollection;
    private _clockHandler: ClockHandler;
    private _terrainService: TerrainService;
    constructor(
        zoneCollection: ZoneCollection,
        clockHandler: ClockHandler,
        terrainService: TerrainService,
    ) {
        this._zoneCollection = zoneCollection;
        this._clockHandler = clockHandler;
        this._terrainService = terrainService;
    }

    public async getPositionForLabel3DModeEnabled(
        cesiumZone: CesiumZone,
    ): Promise<Cesium.Cartesian3> {
        const imsZone = this._zoneCollection.get(cesiumZone.id);
        const labelCartesian = ZoneService.activePosition(
            imsZone,
            this._clockHandler.getCursorTimeAsJulian(),
        );
        if (labelCartesian) {
            return this._calculateLabelCartographic(labelCartesian);
        } else {
            return cesiumZone.labelPosition;
        }
    }

    private async _calculateLabelCartographic(
        labelCartesian: Cesium.Cartesian3,
    ): Promise<Cesium.Cartesian3> {
        const labelCartographic = Cesium.Ellipsoid.WGS84.cartesianToCartographic(labelCartesian);
        if (labelCartographic) {
            const cesiumPromise = Cesium.sampleTerrain(
                this._terrainService.cesiumTerrainProvider,
                this._terrainService.terrainDetailLevel,
                [labelCartographic],
            );
            await Promise.resolve(cesiumPromise);
        }
        // jam in a temporary height so we don't try and convert an undefined
        if (!labelCartographic.height) {
            labelCartographic.height = 0;
        }
        return Cesium.Ellipsoid.WGS84.cartographicToCartesian(labelCartographic);
    }

    public getPositionForLabel2DModeEnabled(cesiumZone: CesiumZone): Cesium.Cartesian3 {
        const imsZone = this._zoneCollection.get(cesiumZone.id);
        return ZoneService.activePosition(imsZone, this._clockHandler.getCursorTimeAsJulian());
    }
}
